import { clamp } from "lodash";

/**
 * Returns a percentage based on current position and total position
 * Often used in tandem with <ProgressBar /> component
 *
 * @param {number} total    count of all items
 * @param {number} current  count of current items
 * @param {number} offsetBy amount to offset items
 *   useful in swan-form where conditional slides are included
 *   in total slide count, so slide count gets inflated
 * @return {number} percentage
 */
export const getPercent = (total: number, current: number, offsetBy: number = 0): number => {
  const adjustedTotal = total - offsetBy;
  if (current >= adjustedTotal) {
    return 100;
  }
  return clamp((100 / adjustedTotal) * current, 0, 100);
};

/**
 * Formats percent using a fixed-point notation
 *
 * @param {string | number} percent
 * @param {number} decimals
 * @return {string}
 */
export function formatPercent(percent: string | number, decimals: number = 3) {
  return `${Number(percent).toFixed(decimals)}%`;
}

/**
 * Formats decimal using a fixed-point notation
 *
 * @param {string | number} decimal
 * @param {number} precision
 * @return {string}
 */
export function formatDecimal(decimal: string | number, precision: number = 3) {
  return `${Number(decimal).toFixed(precision)}`;
}

/**
 * Ceil value after 2 decimal places
 *  * @example
 * returns '80.01%'
 * ceilDecimal(80.0000338386, 2);
 * @param {number} decimal
 * @param {number} precision
 * @return {string}
 */

export function formatCeilDecimal(number: number, precision: number = 3): string {
  return `${(Math.ceil(number * 100) / 100).toFixed(precision)}%`;
}
